import { CSSProperties } from 'react';
import Pin from './Pin';

export interface Props {
  animate?: boolean;
  className?: string;
  baseSize?: number;
}

function Logo({ animate, className, baseSize }: Props) {
  return (
    <div
      className={`Logo${animate ? ' animate' : ''}${
        className ? ` ${className}` : ''
      }`}
      style={
        baseSize
          ? ({ '--base-size': `${baseSize}rem` } as CSSProperties)
          : undefined
      }
    >
      <Pin className={`pin-6${animate ? ' animate' : ''}`} />
      <Pin className={`pin-7${animate ? ' animate' : ''}`} />
      <Pin className={`pin-8${animate ? ' animate' : ''}`} />
      <Pin className={`pin-9${animate ? ' animate' : ''}`} />
      <Pin className={`pin-10${animate ? ' animate' : ''}`} />
      <Pin className={`pin-1${animate ? ' animate' : ''}`} />
      <Pin className={`pin-2${animate ? ' animate' : ''}`} />
      <Pin className={`pin-3${animate ? ' animate' : ''}`} />
      <Pin className={`pin-4${animate ? ' animate' : ''}`} />
      <Pin className={`pin-5${animate ? ' animate' : ''}`} />
    </div>
  );
}

export default Logo;
